
// @ts-nocheck


export const localeCodes =  [
  "en",
  "de",
  "pl"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46yml_426065d1",
      load: () => import("#nuxt-i18n/426065d1" /* webpackChunkName: "locale_en_46yml_426065d1" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_en_46yml_426065d1",
      load: () => import("#nuxt-i18n/426065d1" /* webpackChunkName: "locale_en_46yml_426065d1" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_en_46yml_426065d1",
      load: () => import("#nuxt-i18n/426065d1" /* webpackChunkName: "locale_en_46yml_426065d1" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-GB",
      name: "English",
      flag: "🇬🇧",
      files: [
        {
          path: "/app/apps/web/src/locales/en.yml",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      language: "de-DE",
      name: "Deutsch",
      flag: "🇩🇪",
      files: [
        {
          path: "/app/apps/web/src/locales/en.yml",
          cache: undefined
        }
      ]
    },
    {
      code: "pl",
      language: "pl-PL",
      name: "Polski",
      flag: "🇵🇱",
      files: [
        {
          path: "/app/apps/web/src/locales/en.yml",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "../src/locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-GB",
    name: "English",
    flag: "🇬🇧",
    files: [
      {
        path: "/app/apps/web/src/locales/en.yml",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    language: "de-DE",
    name: "Deutsch",
    flag: "🇩🇪",
    files: [
      {
        path: "/app/apps/web/src/locales/en.yml",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    language: "pl-PL",
    name: "Polski",
    flag: "🇵🇱",
    files: [
      {
        path: "/app/apps/web/src/locales/en.yml",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/